// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ContentZone from "@store/Library/Components/ContentZone";
import * as React from "react";

const enum fields {
    readMore = "readMore",
}

type Props = WidgetProps & HasProduct;

const ProductDetailsKeyFeatures: React.FC<Props> = ({ product, fields: { readMore = "2" } }) => {
    const title = translate("Key Features");
    const content = product.content?.htmlContent;

    if (!content) {
        return null;
    }
    return <ContentZone content={content} contentCellWidth={12} readMore={readMore} />;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsKeyFeatures),
    definition: {
        displayName: "Key Features",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.readMore,
                displayName: "Read More (lines displayed, use array of 5 values for breakpoints)",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
